
// Loan Type Options
export const LOAN_TYPE_OPTIONS = [
  { value: 'home-loan', label: 'Loan For Your Dream Home' },
  { value: 'loan-against-property', label: 'Loan Against Your Property' }
];

// Authorization text
export const AUTHORIZATION_TEXT = 'I hereby authorize communication via Call, Email, SMS and WhatsApp regarding Sammaan Capital Limited products and consent to override any DNC/NDNC registrations.';
